/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_View_Diet_BodyInputs */

const en_platform_view_diet_body = /** @type {(inputs: Platform_View_Diet_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The calorie and macro targets you set, next to what the client has eaten.`)
};

const pl_platform_view_diet_body = /** @type {(inputs: Platform_View_Diet_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cel kalorii i makro, które ustawiłeś, a obok to, co podopieczny już zjadł.`)
};

/**
* | output |
* | --- |
* | "The calorie and macro targets you set, next to what the client has eaten." |
*
* @param {Platform_View_Diet_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_view_diet_body = /** @type {((inputs?: Platform_View_Diet_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_View_Diet_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_view_diet_body(inputs)
	return en_platform_view_diet_body(inputs)
});